import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisVertical } from '@fortawesome/free-solid-svg-icons';

const Navigation = () => {

  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Detecta si la posición del scroll es mayor que el alto de la barra de navegación
      if (window.scrollY > 100) { // Ajusta el valor 100 según el alto de tu barra
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    // Limpiar el evento cuando el componente se desmonta
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <nav className={`nav ${isSticky ? 'sticky' : ''}`}>
      <a href="#services">Servicios</a>
      <FontAwesomeIcon icon={faEllipsisVertical}/>
      <a href="#projects">Proyectos</a>
      <FontAwesomeIcon icon={faEllipsisVertical}/>
      <a href="#contact">Contacto</a>
    </nav>
  );
};

export default Navigation;